import React, { useState } from 'react';
import './Directors.css';
import director1 from '../assets/images/director-1.png.png';
import director2 from '../assets/images/director-2.png.png';
import director3 from '../assets/images/director-3.png.png';

function Directors() {
  const [activeDirector, setActiveDirector] = useState(null);

  const directors = [
    {
      image: director1,
      name: 'Sunil Sachdeva',
      role: 'Director',
      bio: [
        { text: 'Seasoned entrepreneur with ', bold: false },
        { text: '40+ years of experience across power, healthcare, financial services, technology, and infrastructure.', bold: true },
        { text: ' Began career in the power sector (1984-2000), leading execution and commissioning of 100+ substations. Built strong expertise in power infrastructure development and project execution', bold: false },
      ],
      details: [
        { label: 'Chairman of Eleven', text: ' (formerly SAS Group), a diversified group across healthcare, financial services, technology, and clean energy. Successfully built and scaled multiple ventures across sectors. Focus on long-term value creation, operational excellence, and institution building' },
        { label: 'Co-founded Medanta', text: ' - The Medicity in 2004 with Dr. Naresh Trehan. One of India\'s leading multi-super specialty hospital chains having 6 hospitals with ~3,600 beds. Ranked #1 hospital in India for six consecutive years: Gurgaon flagship (~1,500 beds) is among the largest single-location hospitals in India' },
        { label: 'Co-founder of SVCL,', text: ' focused on financial access to micro entrepreneurs in Bharat. Served 19 lakh+ customers and enabled 10,000+ crore in credit disbursals. Operates across 11 states with 285+ branches' },
      ],
      accolades: [
        'Top 200 Self-Made Entrepreneurs of the Millennium - IDFC (2026)',
        'India\'s Most Respected Entrepreneur - Healthcare - Hurun India (2024)',
      ],
    },
    {
      image: director2,
      name: 'Mr Anil Kumar Jha',
      role: 'Director',
      bio: [
        { text: 'Mr Anil Kumar Jha is ', bold: false },
        { text: 'B. Tech. in Mining from IIT (ISM), Dhanbad and M. Tech. in Mine Planning & Design from IIT(ISM), Dhanbad', bold: true },
        { text: '. He has three decades of experience under his belt in mine planning, production, management supervision direction and control of underground as well as open cast coal mines. He began his career in coal mining industry in 1983 in Central Coalfields Limited. He also served as General Manager in Central Coalfields Limited. He was Chairman & Managing Director of Coal India Limited (CIL).', bold: false },
      ],
      details: [],
      accolades: [],
    },
    {
      image: director3,
      name: 'Manoj Kumar Vats',
      role: 'Director',
      bio: [
        { text: '', bold: false },
        { text: 'Brings 35+ years of experience, including serving as Director/Technical at HVPNL', bold: true },
        { text: ', where he provided executive leadership for state-wide transmission networks and the integration of new generation sources.', bold: false },
      ],
      details: [],
      accolades: [],
    },
  ];

  return (
    <section className="directors">
      <h2>Board of directors</h2>
      <p className="directors-description">
        Eleven power is powered by people who think differently, build boldly, and lead from the front. Our teams combine heart and hustle, strategy and execution, vision and detail.
      </p>

      <div className="directors-grid">
        {directors.map((director, index) => (
          <div key={index} className="director-card">
            <div className="director-info">
              <h3>{director.name}</h3>
              <span>{director.role}</span>
              <button
                className="director-link"
                aria-label={`Learn more about ${director.name}`}
                onClick={() => setActiveDirector(index)}
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M1 13L13 1M13 1H1M13 1V13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            <div className="director-image">
              <img src={director.image} alt={director.name} />
            </div>
          </div>
        ))}
      </div>

      {activeDirector !== null && (
        <div className="director-popup-overlay" onClick={() => setActiveDirector(null)}>
          <div className="director-popup" onClick={(e) => e.stopPropagation()}>
            <button className="director-popup-close" onClick={() => setActiveDirector(null)} aria-label="Close">
              ×
            </button>
            <h3>{directors[activeDirector].name}</h3>
            <span className="director-popup-role">{directors[activeDirector].role}</span>
            <div className="director-popup-bio">
              <p>
                {directors[activeDirector].bio.map((part, i) => (
                  part.bold ? <strong key={i}>{part.text}</strong> : <span key={i}>{part.text}</span>
                ))}
              </p>
            </div>
            {directors[activeDirector].details.length > 0 && (
              <div className="director-popup-details">
                {directors[activeDirector].details.map((detail, i) => (
                  <p key={i}><strong>{detail.label}</strong>{detail.text}</p>
                ))}
              </div>
            )}
            {directors[activeDirector].accolades.length > 0 && (
              <div className="director-popup-accolades">
                <p><strong>Recognized with multiple accolades:</strong></p>
                <ul>
                  {directors[activeDirector].accolades.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
}

export default Directors;
